import * as React from 'react';
import { translate } from 'react-i18next';
import { browserHistory, RouteComponentProps } from 'react-router';
import { WhiteButton } from 'components';
import * as c from 'models/constants';
import { PortalPageSection, ButtonsSection, PortalOneColumnLayout } from 'components/PortalStructure';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { getOrderById } from 'redux/modules/shop/orders';
import { formatDuration, readURLSearchParams } from 'helpers/common';
import { IShopCardData } from 'models/shop/shopcard';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { isRestrictedModeQuery, momentWithTimezone } from 'redux/modules/shop/helpers';
require('./style.scss');

interface IProps extends RouteComponentProps<any, {}> {
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	t?: (key: string) => string;
	shopCard?: IShopCardData;

	getOrderById?: (orderId: string) => Promise<void>;
	getShopCard: (shopId: string) => Promise<void>;
	bookedOrder?: any;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		bookedOrder: state.shopOrders.bookedOrder,
		shopCard: state.shopcard,
	}),
	(dispatch) => ({
		getOrderById: (orderId: string) => dispatch(getOrderById(orderId)),
		getShopCard: (shopId: string) => dispatch(getShopCard(shopId, false)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CartThankYou extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.getOrderById = this.getOrderById.bind(this);
		this.handleGoToHomepageClick = this.handleGoToHomepageClick.bind(this);
	}

	public handleGoToHomepageClick() {
		const restrictedMode = isRestrictedModeQuery(this.props.location);
		const shopUrl = restrictedMode ? `/myShop/${this.props?.shopCard?.shopcard?.code}` : '/home';
		browserHistory.push(shopUrl);
	}

	public getOrderById(orderId: string) {
		this.props.getOrderById(orderId).then(() => {
			if (this.props.bookedOrder?.items?.length > 0) {
				this.props.getShopCard(this.props.bookedOrder.items[0].shopId);
			}
		});
	}

	componentDidMount(): void {
		this.getOrderById(readURLSearchParams('order_id'));
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { t, bookedOrder, shopCard } = this.props;
		const timezone = bookedOrder?.items[0]?.officeZoneInfo;

		var shopImage = require('containers/Html/images/thankyou/thank_you_icon.png');
		if (shopCard != null && shopCard.shopcard?.picture != null) {
			shopImage = shopCard.shopcard?.picture;
		}

		let sortedBookedOrder = bookedOrder?.items || [];

		if (bookedOrder?.items?.length > 0) {
			sortedBookedOrder = bookedOrder.items.sort((a, b) => {
				const timeA = a.productSchedule;
				const timeB = b.productSchedule;

				if (momentWithTimezone(timezone, timeA).isBefore(momentWithTimezone(timezone, timeB))) {
					return -1;
				}

				if (momentWithTimezone(timezone, timeA).isAfter(momentWithTimezone(timezone, timeB))) {
					return 1;
				}

				return 0;
			});
		}

		let totalDuration = 0;

		sortedBookedOrder.map((item) => {
			totalDuration = totalDuration + item.productDuration;
		});

		return (
			<div className="cartThankYouBackground">
				<PortalOneColumnLayout className="cartThankYouWrapper">
					<div className="cartThankYou">
						<PortalPageSection variant="white">
							<h1 className="title">
								{t('Cart_CartThankYou_Label_ThankYou')}
								<span> {t('Cart_CartThankYou_Label_ThankYou_Part2')}</span>
							</h1>
							<div className="textWrapper desc">
								<span className="text font-20">{t('Cart_CartThankYou_Desc')}</span>
							</div>
							<div className="textWrapper">
								<p className="font-weight-bold font-24">
									{momentWithTimezone(timezone, sortedBookedOrder[0]?.productSchedule).format('LLLL')}
								</p>
								<span className="bookingAppointment__scheduleStep__mainDetails__timeSubtext">
									{formatDuration(totalDuration)} {t('BookAppointment_Schedule_Duration')}{' '}
									{momentWithTimezone(timezone, sortedBookedOrder[sortedBookedOrder.length - 1]?.productSchedule)
										.clone()
										.add(sortedBookedOrder[sortedBookedOrder.length - 1]?.productDuration, 'seconds')
										.format('LT')}
								</span>
								<div className="cartThankYou__locationInfo">
									<div className="iconWrapper">
										<img src={shopImage} className="icon" />
									</div>
									<div className="data">
										<p className="font-weight-bold">{sortedBookedOrder[0]?.shopName}</p>
										<span className="text">{sortedBookedOrder[0]?.officeName}</span>
									</div>
								</div>
							</div>
						</PortalPageSection>
						<ButtonsSection>
							<WhiteButton type="button" onClick={this.handleGoToHomepageClick}>
								{t('Cart_CartThankYou_Button_Homepage')}
							</WhiteButton>
						</ButtonsSection>
					</div>
				</PortalOneColumnLayout>
			</div>
		);
	}
}

export { CartThankYou };

declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace JSX {
		interface IntrinsicElements {
			['add-to-calendar-button']: any;
		}
	}
}
